<template>
	<div v-if="data">
		<div class="row">
			<div class="col-lg-12 p-r-5 p-l-5">
				<iframe
					class="embed-responsive-item"
					:src="link"
					:height="iframe.style.height"
					:width="iframe.style.width"
					@load="resizeIframe($event)" frameborder="0">
				</iframe>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				random: this.$route.params.random,
				data: null,
				link: null,

				iframe: {
					style: {
						width: null,
						height: null,
					},
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getData() {
				if(this.random) {
					this.$http.get('management/invoices/' + this.random)
					.then(response => {
						this.data = response.body
						this.loadLink()
					}, function(error) {
						console.log(error)
					})
				}
			},
			loadLink() {
				this.link = this.$env.ROOT + '/' + this.$lang.getLang() + '/' + this.$platform.slug +'/pdf/viewer'
				if(this.data) {
					if(this.data.link) {
						this.link = this.link + '?file=' + this.data.link
					}
				}
			},
			resizeIframe() {
				this.iframe.style = {
					width: '100%',
					height: window.innerHeight,
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/public/management/invoices/views/InvoiceViewer.vue